import { useState, useEffect, useContext, useRef } from 'react';
import Breadcrumbs from '../../../global/Components/Breadcrumb/Breadcrumb';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import Product from '../../../global/Components/Items/Product/Product';
import { Col, Row, Spinner } from 'reactstrap';
import PaginationComponent from '../../../global/Components/Pagination/PaginationComponent';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import { Toast } from 'primereact/toast';

const FAVORITE_URL = 'api/v1/user-favorites';

export default function FavoriteList() {
  const apiPrivate = useApiPrivate();
  // const [searchParams, setSearchParams] = useSearchParams();
  const {lang} = useContext(UserContext);
  const toast = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [wishlists, setWishlists] = useState([]);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState();

  const showError = (message) => {
    toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const getWishLists = async () => {
    setIsLoading(true);

    await apiPrivate.get(`${FAVORITE_URL}`,{
      params:{
        limit: '2',
        page: currentPage && currentPage,
      }
    })
      .then(function(response){
        setWishlists(response?.data?.data);
        setMetaData(response?.data?.meta);
        setCurrentPage(response?.data?.meta?.current_page);
        setIsLoading(false);
      })
      .catch(function(error){
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message)
        } 
        setIsLoading(false);
      })
    }
    
    useEffect(() => {
      getWishLists();
    },[])
    
    useEffect(() => {
      getWishLists();
      // currentPage &&
      // searchParams.set('page', currentPage);
      // setSearchParams(searchParams);
      
    },[currentPage])
    
  return (
    <>
      <Toast ref={toast} position="top-center" />
    <Row>
        <Col sm={8} md={8}>
          <Breadcrumbs />
        </Col>
        <Col sm={4} md={4}>
          <div className={`text-end fsSmall`}>
            {
            metaData ? (
              <>
                {metaData.total}
                <span>
                  {' '}{showMsg('results', lang)}
                </span>
              </>
            ) : (
              <span>
                {showMsg('no_results', lang)}
              </span>
            )
            }
          </div>
        </Col>
      </Row>
      {
        isLoading 
          ? <div className='text-center my-4'>
              <Spinner color='primary'>
                Loading...
              </Spinner> 
            </div>
          : <div>
              {
                wishlists.length > 0 
                  ? (
                    <Row>
                      {
                        wishlists.map((product) => (
                          <Col className='col-12 col-sm-6 col-md-4 col-xxl-3' key={product.id}>
                            <div className='ps-2'>
                              <Product data={product.product} isWishlist={true} />
                            </div>
                          </Col>
                        ))
                      }
                    </Row>
                  ) 
                  : (
                    <p className="fw-bold py-4">No Products to display</p>
                  )
              }
            </div>
      }
      <Row>
        <Col sm={12}>
          {
            metaData &&
              metaData.last_page > 1 
                ? (
                  <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData}/>
                ) 
                : ('')
          }                          
        </Col>
      </Row>
    </>
  )
}
